export function loadDictionary() {
  const dictionary = load();

  const res = dictionary.map((item) => {
    const map = new Map();
    item.data.forEach((item) => map.set(item.code, item));
    return {
      ...item,
      data: map,
    };
  });

  return res;
}

export function load() {
  let dictionary = [];

  dictionary[4] = {
    value: "Виды профилей специализации ИТЗ",
    data: [
      { code: "1", value: "Педиатрия" },
      { code: "2", value: "Терапия" },
      { code: "3", value: "Гериатрия" },
      { code: "4", value: "Хирургия" },
      { code: "5", value: "Акушерство" },
      { code: "6", value: "Психиатрия" },
      { code: "7", value: "Стоматология" },
      { code: "8", value: "Социология" },
      { code: "9", value: "Вспомогательные методы исследования" },
    ],
  };

  dictionary[5] = {
    value: "Факторная направленность",
    data: [
      { code: "1", value: "Поведенческие" },
      { code: "2", value: "Генетические" },
      { code: "3", value: "Экологические" },
      { code: "4", value: "Медицинские" },
      { code: "5", value: "Социальные" },
      { code: "6", value: "Профессиональные (вредности)" },
    ],
  };

  dictionary[6] = {
    value: "Управляющие здоровьесберегательные направленности ИТЗ",
    data: [
      {
        code: "01",
        value:
          "Выявление риска или заболевания (в т.ч. первичная профилактика)",
      },
      {
        code: "02",
        value: "Предотвращение реализации рисков и развития заболевания",
      },
      {
        code: "03",
        value: "Коррекция риска и/или лечение",
      },
      {
        code: "04",
        value: "Компенсация последствий (реабилитация/абилитация и т.п.)",
      },
      {
        code: "05",
        value: "Вспомогательная",
      },
    ],
  };

  dictionary[7] = {
    value: "Основополагающие ФНПА в сфере ЗБ",
    data: [
      {
        code: "0",
        value: "Отсутствует НПА",
      },
      {
        code: "01",
        value: "Законы",
        children: [
          {
            code: "0101",
            value:
              "Федеральный закон от 10 июля 2001 года №87-ФЗ «Об ограничении курения табака»",
          },
          {
            code: "0102",
            value:
              "Федеральный закон Российской Федерации от 23 февраля 2013 года №15-ФЗ «Об охране здоровья граждан от воздействия окружающего табачного дыма и последствий потребления табака»",
          },
          {
            code: "0103",
            value:
              "Федеральный закон от 30.03.1999 N 52-ФЗ (ред. от 26.07.2019) «О санитарно-эпидемиологическом благополучии населения»",
          },
          {
            code: "0104",
            value:
              "Федеральный закон ФЗ от 29.11.2010 №326-ФЗ «Об обязательном медицинском страховании в Российской Федерации»",
          },
          {
            code: "0105",
            value:
              "Федеральный закон от 21.11.2011 N 323-ФЗ (ред. от 01.04.2020) «Об основах охраны здоровья граждан в Российской Федерации»",
          },
          {
            code: "0106",
            value:
              "Федеральный закон №15 от 23 февраля 2013 г. «Об охране здоровья граждан от воздействия окружающего табачного дыма и последствий потребления табака»",
          },
        ],
      },
      {
        code: "02",
        value: "Постановления Правительства РФ",
        children: [
          {
            code: "0201",
            value:
              "Постановление Правительства Российской Федерации от 13 сентября 2005 года №561 «О Федеральной целевой программе «Комплексные меры противодействия злоупотреблению наркотиками и их незаконному обороту на 2005-2009 годы»",
          },
          {
            code: "0202",
            value:
              "Постановление Правительства Российской Федерации от 21 декабря 2007 года№1260 «Долгосрочная программа «Здоровый образ жизни»",
          },
          {
            code: "0203",
            value:
              "Постановление Правительства Российской Федерации от 23 декабря 2013 года №1214 «Об утверждении Положения о проведении мониторинга и оценки эффективности реализации мероприятий, направленных на предотвращение воздействия окружающего табачного дыма и сокращения потребления табака»",
          },
          {
            code: "0204",
            value:
              "Постановление Правительства Российской Федерации от 23 декабря 2013 года №1214 «Об утверждении Положения о проведении мониторинга и оценки эффективности реализации мероприятий, направленных на предотвращение воздействия окружающего табачного дыма и сокращения потребления табака»",
          },
          {
            code: "0205",
            value:
              "Указ Президента РФ от 07.05.2018 N 204 (ред. от 19.07.2018) «О национальных целях и стратегических задачах развития Российской Федерации на период до 2024 года»",
          },
        ],
      },
      {
        code: "03",
        value: "Указы Президента",
        children: [
          {
            code: "0301",
            value:
              "Указ Президента Российской Федерации от 9 июня 2010 года №690 «Об утверждении стратегии государственной антинаркотической политики Российской Федерации до 2020 года»",
          },
        ],
      },
      {
        code: "04",
        value: "Национальные проекты",
        children: [
          {
            code: "0401",
            value:
              "Федеральный проект Паспорт федерального проекта. Формирование системы мотивации граждан к здоровому образу жизни, включая здоровое питание и отказ от вредных привычек (Укрепление общественного здоровья»",
          },
        ],
      },
      {
        code: "05",
        value: "Приказы МЗ РФ",
        children: [
          {
            code: "0501",
            value:
              "Приказ Минздрава СССР от 14 октября 1988 года №770 «О совершенствовании гигиенического воспитания населения и пропаганды здорового образа жизни»",
          },
          {
            code: "0502",
            value:
              "Приказ Минздрава России от 22 декабря 1995 года №364 «О мерах по развитию медицинской профилактики в Российской Федерации»",
          },
          {
            code: "0503",
            value:
              "Приказ Минздрава России от 5 июля 1997 года №232 «О создании центра и региональных групп мониторинга вредных привычек среди детей и подростков»",
          },
          {
            code: "0504",
            value:
              "Приказ Минздрава России от 26 ноября 1997 года №344 «О создании Координационного центра и региональных кабинетов профилактики неинфекционных заболеваний и факторов риска»",
          },
          {
            code: "0505",
            value:
              "Приказ Минздрава России от 22 июня 1998 года №199 «О мерах по профилактике курения в лечебно-профилактических учреждениях и Минздраве России»",
          },
          {
            code: "0506",
            value:
              "Приказ Минздрава России от 29 сентября 2003 года №455 «О совершенствовании деятельности органов и учреждений здравоохранения по профилактике заболеваний в Российской Федерации»",
          },
          {
            code: "0507",
            value:
              "Приказ Минздравсоцразвития России от 19 августа 2009 года №597н «Об организации деятельности центров здоровья по формированию здорового образа жизни у граждан Российской Федерации, включая сокращение потребления алкоголя и табака»",
          },
          {
            code: "0508",
            value:
              "Приказ Минздравсоцразвития России от 19 апреля 2011 г. N 328н «О внесении изменений в приложения N 1 - 5 к приказу Министерства здравоохранения и социального развития Российской Федерации от 19 августа 2009 г. N 597н",
          },
          {
            code: "0509",
            value:
              "Приказ Минздравсоцразвития России от 26 сентября 2011 г. N 1074н «О внесении изменений в приказ Министерства здравоохранения и социального развития Российской Федерации от 19 августа 2009 г. N 597н",
          },
          {
            code: "0510",
            value:
              "Приказ Минздрава России от 30 сентября 2015 г. N 683н «Об утверждении Порядка организации и осуществления профилактики неинфекционных заболеваний и проведения мероприятий по формированию здорового образа жизни в медицинских организациях",
          },
          {
            code: "0511",
            value:
              "Приказ Минздрава России от 15 ноября 2016 г. № 859н «Об утверждении Методики проведения мониторинга и оценки эффективности реализации мероприятий, направленных на предотвращение воздействия окружающего табачного дыма и сокращение потребления табака»",
          },
          {
            code: "0512",
            value:
              "Приказ Минздрава России от 19 августа 2016 г. № 614 «Об утверждении рекомендаций по рациональным нормам потребления пищевых продуктов, отвечающих современным требованиям здорового питания»",
          },
          {
            code: "0513",
            value:
              "Приказ Минздрава России от 30 июня 2016 г. № 448н «Об утверждении Концепции по информированию населения Российской Федерации о вреде злоупотребления алкоголем»",
          },
          {
            code: "0514",
            value:
              "Приказ МЗ РФ от 19.04.1999 №135 «О совершенствовании системы Государственного Ракового Регистра»",
          },
          {
            code: "0515",
            value:
              "Приказ Минздравсоцразвития России от 8 июня 2010 года № 430н «О внесении изменений в Приказ Министерства здравоохранения и социального развития Российской Федерации от 19 августа 2009 г. N 597н «Об организации деятельности центров здоровья по формированию здорового образа жизни у граждан Российской Федерации, включая сокращение потребления алкоголя и табака",
          },
          {
            code: "0516",
            value:
              "Приказ Минздравсоцразвития России от 16.03.2010 года № 152н «О мерах, направленных на формирование здорового образа жизни у граждан Российской Федерации, включая сокращение потребления алкоголя и табака",
          },
          {
            code: "0517",
            value:
              "Приказ ФОМС от 07.04.2011 №79 «Об утверждении Общих принципов построения и функционирования информационных систем и порядок информационного взаимодействия в сфере обязательного медицинского страхования»",
          },
          {
            code: "0518",
            value:
              "Приказ МЗ РФ №560н от 31.10.2012 года «Об утверждении Порядка оказания медицинской помощи населению по профилю «Детская онкология»",
          },
          {
            code: "0519",
            value:
              "Приказ Минздравсоцразвития России от 15.05.2012 № 543н «Об утверждении Положения об организации оказания первичной медико-санитарной помощи взрослому населению»",
          },
          {
            code: "0520",
            value:
              "Приказ Минздрава России от 21.12.12 №1344н «Об утверждении порядка проведения диспансерного наблюдения»",
          },
          {
            code: "0521",
            value:
              "Приказ Министерства здравоохранения Российской Федерации № 915н от 15.11.12 г. «Об утверждении Порядка оказания медицинской помощи взрослому населению по профилю «онкология»",
          },
          {
            code: "0522",
            value:
              "Приказ Минздрава РФ от 15 ноября 2012 г № 918н «Об утверждении Порядка оказания медицинской помощи больным с сердечно-сосудистыми заболеваниями»",
          },
          {
            code: "0523",
            value:
              "Приказ Министерства здравоохранения РФ от 5 ноября 2013 г. № 822н «Об утверждении Порядка оказания медицинской помощи несовершеннолетним, в том числе в период обучения и воспитания в образовательных организациях",
          },
          {
            code: "0524",
            value:
              "Приказ Минздрава РФ от 30.09.2013 г. № 677 «Об утверждении информационно-коммуникационной стратегии по формированию ЗОЖ",
          },
          {
            code: "0525",
            value:
              "Приказ Министерства здравоохранения РФ от 21 марта 2014 г. N 125н «Об утверждении национального календаря профилактических прививок и календаря профилактических прививок по эпидемическим показаниям» (с изм. и доп.)",
          },
          {
            code: "0526",
            value:
              "Приказ Минздрава России от 30 сентября 2015 г. N 683н «Об утверждении Порядка организации и осуществления профилактики неинфекционных заболеваний и проведения мероприятий по формированию здорового образа жизни в медицинских организациях»",
          },
          {
            code: "0527",
            value:
              "Приказ Минздрава России от 15 ноября 2016 г. № 859н «Об утверждении Методики проведения мониторинга и оценки эффективности реализации мероприятий, направленных на предотвращение воздействия окружающего табачного дыма и сокращение потребления табака»",
          },
          {
            code: "0528",
            value:
              "Приказ Минздрава России от 19 августа 2016 г. № 614 «Об утверждении рекомендаций по рациональным нормам потребления пищевых продуктов, отвечающих современным требованиям здорового питания»",
          },
          {
            code: "0529",
            value:
              "Приказ Минздрава России от 30 июня 2016 г. № 448н «Об утверждении Концепции по информированию населения Российской Федерации о вреде злоупотребления алкоголем»",
          },
          {
            code: "0530",
            value:
              "Приказ Министерства здравоохранения РФ от 10 августа 2017 г. N 514н «О Порядке проведения профилактических медицинских осмотров несовершеннолетних» (с изм. и доп.)",
          },
          {
            code: "0531",
            value:
              "Приказ Минздрава России от 2017 года №804н «О номенклатуре медицинских услуг»",
          },
          {
            code: "0532",
            value:
              "Приказ МЗ РФ от 29.03.2019 №173н Об утверждении порядка проведения диспансерного наблюдения за взрослыми",
          },
          {
            code: "0533",
            value:
              "Приказ Минздрава России от 13.03.2019 г. № 124н «Об утверждении порядка проведения профилактического медицинского осмотра и диспансеризации определенных групп взрослого населения»",
          },
          {
            code: "0534",
            value:
              "Приказ Минздрава России №108н от 28.02.2019 «Об утверждении Правил обязательного медицинского страхования»",
          },
        ],
      },
      {
        code: "06",
        value: "Распоряжения Правительства РФ",
        children: [
          {
            code: "0601",
            value:
              "Распоряжение Правительства Российской Федерации от 30 декабря 2009 года №2128-р «О Концепции реализации государственной политики по снижению масштабов злоупотребления алкогольной продукцией и профилактике алкоголизма среди населения Российской Федерации на период до 2020 года»",
          },
        ],
      },
      {
        code: "07",
        value: "Приказы субъекта РФ",
        children: [
          {
            code: "0701",
            value: "",
          },
        ],
      },
      {
        code: "08",
        value: "Письма МЗ РФ",
        children: [
          {
            code: "0801",
            value:
              "письмо Минздрава России от 29.10.2015 № 17-9/10/2-6495 «О реализации мероприятий по профилактике заболеваний и формированию здорового образа жизни»",
          },
        ],
      },
    ],
  };

  dictionary[8] = {
    value: "Целевые показатели",
    data: [
      { code: "1", value: "Младенческая и материнская смертность" },
      { code: "2", value: "Смертность" },
      { code: "3", value: "Рождаемость" },
      { code: "4", value: "Средняя ожидаемая продолжительность жизни" },
      { code: "5", value: "Заболеваемость" },
      { code: "6", value: "Инвалидизация/Качество жизни" },
      { code: "7", value: "Продолжительность жизни" },
      { code: "8", value: "Повышение клинико-экономической эффективности" },
    ],
  };

  dictionary[10] = {
    value: "Протокол исследования",
    data: [
      {
        code: "01",
        value: "Авторский, не утвержденный в МБКИ",
      },
      {
        code: "02",
        value: "Авторский,Утвержденный в МБКИ",
      },
      {
        code: "03",
        value: "Отсутствуют",
      },
      {
        code: "04",
        value: "Других авторов, утвержденный в МБКИ",
      },
    ],
  };

  dictionary[11] = {
    value: "Опросники для проведения НИР",
    data: [
      {
        code: "01",
        value: "Авторские, неутвержденные в МБКИ",
      },
      {
        code: "02",
        value: "Авторские, Утвержденные в МБКИ",
      },
      {
        code: "03",
        value: "Других авторов, утвержденные МБКИ",
      },
    ],
  };

  dictionary[12] = {
    value: "Виды рассмотрения на Этическом коммитете",
    data: [
      {
        code: "01",
        value: "Имеется решение ЭК международного уровня",
      },
      {
        code: "02",
        value: "Имеется решение ЭК локального уровня",
      },
      {
        code: "03",
        value: "Рассмотрение на этическом комитете отсутствует",
      },
    ],
  };

  dictionary[13] = {
    value: "Клинические исследования и апробация",
    data: [
      {
        code: "1",
        value: "Нет испытаний",
      },
      {
        code: "2",
        value: "Локальный уровень или остальные меньше года",
      },
      {
        code: "3",
        value: "Российский уровень больше года ",
      },
      {
        code: "35",
        value: "Зарубежный уровень больше года ",
      },
      {
        code: "4",
        value: "Международный уровень больше года ",
      },
    ],
  };

  dictionary[14] = {
    value: "Виды правовой основы результатов НИР",
    data: [
      {
        code: "01",
        value: "имеются международные патенты",
      },
      {
        code: "02",
        value: "имеются международные свительства на изобретение",
      },
      {
        code: "03",
        value: "имеются российские патенты",
      },
      {
        code: "04",
        value: "имеются российские свидетельства на изобретение",
      },
      {
        code: "05",
        value: "имеется регистрация на медизделие или лексредство",
      },
      {
        code: "06",
        value: "имеется регистрация как программное обеспечение",
      },
      {
        code: "07",
        value: "отсутствует",
      },
    ],
  };

  dictionary[17] = {
    value: "Виды наград ИТЗ и НИР",
    data: [
      {
        code: "0",
        value: "нет",
      },
      {
        code: "1",
        value: "РФ",
      },
      {
        code: "2",
        value: "Зарубежная",
      },
      {
        code: "3",
        value: "Международная",
      },
    ],
  };

  dictionary[18] = {
    value: "Современность базы исследования",
    data: [
      {
        code: "01",
        value: "Инновационное полностью",
      },
      {
        code: "02",
        value: "Частично инновационное",
      },
      {
        code: "03",
        value: "Рутинное полностью",
      },
      {
        code: "10",
        value: "Неприменимо",
      },
    ],
  };

  dictionary[19] = {
    value: "Новизна",
    data: [
      {
        code: "01",
        value: "Радикальная",
      },
      {
        code: "015",
        value: "Перспективная",
      },
      {
        code: "02",
        value: "Модификация",
      },
      {
        code: "03",
        value: "Рутинное обновление",
      },
      {
        code: "04",
        value: "Копирование",
      },
    ],
  };

  dictionary[20] = {
    value: "Новые специальности/повышение квалификации",
    data: [
      { code: "01", value: "не требуется" },
      { code: "02", value: "повышение квалификации" },
      { code: "03", value: "переподготовка" },
      { code: "04", value: "новая специальность" },
    ],
  };

  dictionary[21] = {
    value: "Новые потребительские характеристики",
    data: [
      {
        code: "01",
        value: "значительные (70-100% новые)",
      },
      {
        code: "02",
        value: "новые частично (50-70%)",
      },
      {
        code: "03",
        value: "некоторое обновление (30-50%)",
      },
      {
        code: "04",
        value: "отсутствуют",
      },
    ],
  };

  dictionary[22] = {
    value: "Необходимость новых расходных материалов",
    data: [
      {
        code: "01",
        value: "Требуются новые",
      },
      {
        code: "02",
        value: "Разрабатываются",
      },
      {
        code: "03",
        value: "Новые не требуются",
      },
    ],
  };

  dictionary[24] = {
    value: "Участники ИТЗ",
    data: [
      {
        code: "01",
        value: "Врачи-терапевты",
      },
      {
        code: "02",
        value: "Врачи-педиатры",
      },
      {
        code: "03",
        value: "Врачи-эндокринологи",
      },
      {
        code: "04",
        value: "Врачи-отоларингологи",
      },
      {
        code: "05",
        value: "Врачи акушеры-гинекологи",
      },
      {
        code: "06",
        value: "Врачи реабилитологи",
      },
      {
        code: "07",
        value: "Врачи диетологи",
      },
      {
        code: "08",
        value: "Специалисты по профилактической медицине",
      },
      {
        code: "09",
        value: "Инструкторы ЛФК",
      },
      {
        code: "10",
        value: "Врачи функциональной диагностики",
      },
      {
        code: "11",
        value: "Врачи спортивной медицины",
      },
      {
        code: "12",
        value: "Врачи онкологи",
      },
      {
        code: "13",
        value: "Врачи кардиологи",
      },
      {
        code: "14",
        value: "Врачи неврологи",
      },
      {
        code: "15",
        value: "Врачи психотерапевты",
      },
      {
        code: "16",
        value: "Медицинские психологи",
      },
      {
        code: "17",
        value: "Психологи",
      },
      {
        code: "18",
        value: "Педагоги",
      },
      {
        code: "19",
        value: "Культурологи",
      },
      {
        code: "20",
        value: "Врач ИРТ",
      },
      {
        code: "21",
        value: "Врач гастроэнтерологи",
      },
      {
        code: "22",
        value: "Врачи нефрологи",
      },
      {
        code: "23",
        value: "Врачи дерматологи",
      },
      {
        code: "24",
        value: "Врачи вертебрологи",
      },
      {
        code: "25",
        value: "Школьные врачи",
      },
      {
        code: "26",
        value: "Экологи",
      },
      {
        code: "27",
        value: "Волонтеры",
      },
      {
        code: "28",
        value: "Поликлиники для взрослых",
      },
      {
        code: "29",
        value: "Детские поликлиники",
      },
      {
        code: "30",
        value: "Женские консультации",
      },
      {
        code: "31",
        value: "Региональные Центры здоровья",
      },
      {
        code: "32",
        value: "Региональные Центры медицинской профилактики",
      },
      {
        code: "33",
        value: "Региональные Центры общественного здоровья",
      },
      {
        code: "34",
        value: "Региональные Центры реабилитации",
      },
      {
        code: "35",
        value: "Корпоративные медицинские центры",
      },
      {
        code: "36",
        value: "Школы",
      },
      {
        code: "37",
        value: "ФАПы",
      },
      {
        code: "38",
        value: "Фельдшер",
      },
      {
        code: "39",
        value: "Федеральные Центры медицинской профилактики",
      },
      {
        code: "40",
        value: "Федеральные Центры реабилитации",
      },
    ],
  };

  dictionary[25] = {
    value: "Виды целевых аудиторий",
    data: [
      {
        code: "01",
        value: "Профессионалы клинического здравоохранения",
      },
      {
        code: "02",
        value: "Администрация здравоохранения",
      },
      {
        code: "03",
        value: "Социальная администрация",
      },
      {
        code: "04",
        value: "Пациенты, в т.ч. хронические",
      },
      {
        code: "05",
        value: "Родственники пациентов",
      },
      {
        code: "06",
        value: "Население (практически здоровое)",
      },
      {
        code: "07",
        value: "Учащиеся",
      },
      {
        code: "08",
        value: "Дети",
      },
      {
        code: "09",
        value: "Младенцы",
      },
      {
        code: "10",
        value: "Беременные",
      },
      {
        code: "11",
        value: "Производство",
      },
    ],
  };

  dictionary[26] = {
    value: "Уровни и условия оказания медицинской помощи",
    data: [
      {
        code: "0",
        value: "Напрямую не участвует (вспомогательная технология)",
      },
      { code: "1", value: "Первичная медико-санитарная помощь" },
      { code: "2", value: "Специализированная медицинская помощь" },
      { code: "3", value: "Скорая медицинская помощь" },
      {
        code: "4",
        value:
          "Вне медицинской организации с использованием дистанционных технологий (телемедицина)",
      },
      { code: "5", value: "Вне медицинской организации" },
      { code: "6", value: "Амбулаторно" },
      { code: "7", value: "В дневном стационаре" },
      { code: "8", value: "Стационарно" },
    ],
  };

  dictionary[27] = {
    value: "Отраслевая направленность",
    data: [
      {
        code: "01",
        value: "Здравоохранение",
      },
      {
        code: "02",
        value: "Образование",
      },
      {
        code: "03",
        value: "Социальная защита",
      },
      {
        code: "04",
        value: "Спорт",
      },
      {
        code: "05",
        value: "Культура",
      },
      {
        code: "06",
        value: "Питание",
      },
      {
        code: "07",
        value: "Информатизация",
      },
      {
        code: "08",
        value: "Химическая промышленность",
      },
      {
        code: "09",
        value: "Сельское хозяйство",
      },
      {
        code: "10",
        value: "Наука",
      },
      {
        code: "11",
        value: "Текстильное производство",
      },
      {
        code: "12",
        value: "РЖД",
      },
      {
        code: "13",
        value: "Авиация",
      },
    ],
  };

  dictionary[28] = {
    value: "Дисциплинарная направленность",
    data: [
      { code: "0", value: "Без специализации" },
      { code: "10", value: "Акушерство и гинекология" },
      { code: "20", value: "Аллергология и иммунология" },
      { code: "30", value: "Анестезиология-реаниматология" },
      { code: "40", value: "Биоинформатика" },
      { code: "50", value: "Гастроэнтерология" },
      { code: "60", value: "Гематология" },
      { code: "70", value: "Генетика" },
      { code: "80", value: "Геномные и другие 'омиксные' технологии" },
      { code: "90", value: "Дерматовенерология" },
      { code: "100", value: "Детская хирургия" },
      { code: "110", value: "Интервенционная кардиология" },
      { code: "120", value: "Инфекционные болезни" },
      { code: "130", value: "Кардиология" },
      { code: "140", value: "Клеточные технологии" },
      { code: "150", value: "Клиническая лабораторная диагностика" },
      { code: "160", value: "Клиническая фармакология" },
      { code: "170", value: "Медицинская информатика" },
      { code: "180", value: "Медицинская микробиология" },
      { code: "190", value: "Неврология" },
      { code: "200", value: "Нейрофизиология" },
      { code: "210", value: "Нейрохирургия" },
      { code: "220", value: "Неонатология" },
      { code: "230", value: "Общая врачебная практика (семейная медицина)" },
      { code: "240", value: "Общая гигиена" },
      { code: "250", value: "Онкология" },
      {
        code: "260",
        value: "Организация здравоохранения и общественное здоровье",
      },
      { code: "270", value: "Остеопатия" },
      { code: "280", value: "Оториноларингология" },
      { code: "290", value: "Офтальмология" },
      { code: "300", value: "Патологическая анатомия" },
      { code: "310", value: "Педиатрия" },
      { code: "320", value: "Перфузиология" },
      { code: "330", value: "Пластическая хирургия" },
      { code: "340", value: "Промышленная фармация" },
      { code: "350", value: "Профилактическая медицина" },
      { code: "360", value: "Психология" },
      { code: "370", value: "Психоневрология" },
      { code: "380", value: "Пульмонология" },
      { code: "390", value: "Радиология" },
      { code: "400", value: "Рентгенология" },
      { code: "410", value: "Сердечно-сосудистая хирургия" },
      { code: "420", value: "Скорая медицинская помощь" },
      { code: "430", value: "Социальная помощь" },
      { code: "440", value: "Спортивная медицина" },
      { code: "450", value: "Стоматология общей практики" },
      { code: "460", value: "Судебно-медицинская экспертиза" },
      { code: "470", value: "Торакальная хирургия" },
      { code: "480", value: "Травматология и ортопедия" },
      { code: "490", value: "Урология" },
      { code: "500", value: "Фармацевтическая химия и фармакогнозия" },
      { code: "510", value: "Физическая и реабилитационная медицина" },
      { code: "520", value: "Фтизиатрия" },
      { code: "530", value: "Хемоинформатика" },
      { code: "540", value: "Челюстно-лицевая хирургия" },
      { code: "550", value: "Эндокринология" },
      { code: "560", value: "Эпидемиология" },
      { code: "580", value: "Ядерная медицина" },
    ],
  };

  dictionary[29] = {
    value: "Возможный уровень внедрения ИТЗ",
    data: [
      {
        code: "01",
        value: "Мировой",
      },
      {
        code: "02",
        value: "Российский",
      },
      {
        code: "03",
        value: "Федеральный округ",
      },
      {
        code: "04",
        value: "Субъект РФ",
      },
      {
        code: "05",
        value: "Медицинская организация",
      },
      {
        code: "06",
        value: "авторский",
      },
    ],
  };

  dictionary[30] = {
    value: "Уровни реальности применения ИТЗ",
    data: [
      {
        code: "01",
        value: "Возможно внедрение в настоящее время",
      },
      {
        code: "02",
        value: "Возможно внедрение в кратковременной перспективе",
      },
      {
        code: "03",
        value: "Возможно внедрение в среднесрочной перспективе",
      },
      {
        code: "04",
        value: "Возможность внедрения в долгосрочной перспективе",
      },
      {
        code: "05",
        value: "Внедрение не может быть",
      },
    ],
  };

  dictionary[33] = {
    value: "Виды ограничений использования ИТЗ",
    data: [
      {
        code: "01",
        value: "Отсутствует специальность врача",
      },
      {
        code: "02",
        value: "Требуется подготовка на центральной базе",
      },
      {
        code: "03",
        value: "Требуется подготовка специалистов зарубежом",
      },
      {
        code: "04",
        value: "Требуется финансирование подготовки специалистов",
      },
      {
        code: "05",
        value: "Нет серийного производства расходных средств в РФ",
      },
      {
        code: "06",
        value: "Нет серийного производства расходных средств в мире",
      },
      {
        code: "07",
        value: "Нет достаточного финансирования приобретения расходных средств",
      },
      {
        code: "08",
        value: "Нет серийного производства необходимого оборудования в стране",
      },
      {
        code: "09",
        value:
          "Нет финансовых средств для приобретения необходимого оборудования ,имеющегося в серийном производстве",
      },
      {
        code: "10",
        value: "Нет серийного производства необходимого оборудования в мире",
      },
      {
        code: "11",
        value: "нет специального помещения для применения ИТЗ",
      },
      {
        code: "12",
        value: "Ограничений нет",
      },
      {
        code: "13",
        value: "Нет бюджетного финансирования",
      },
    ],
  };

  dictionary[34] = {
    value: "Характеристики удобства использования ИТЗ",
    data: [
      {
        code: "01",
        value: "применение ЦА самостоятельно по инструкции",
      },
      {
        code: "02",
        value: "Применение ЦА под контролем контроль врача",
      },
      {
        code: "03",
        value: "Применение ЦА только врачом",
      },
      {
        code: "04",
        value: "применение врачом самостоятельно по инструкции",
      },
      {
        code: "05",
        value: "Применение врачом с постоянным контролем автора",
      },
      {
        code: "06",
        value: "Применение только автором",
      },
      {
        code: "07",
        value:
          "Требуется постоянное поддерживающее крупномасштабное информирование целевых аудиторий",
      },
      {
        code: "08",
        value:
          "Требуется периодическое поддерживающее избирательной информирование целевых аудиторий",
      },
      {
        code: "09",
        value:
          "Требуется периодическое поддерживающее крупномасштабное информирование йелевых аудиторий",
      },
      {
        code: "10",
        value: "Не требуется вводное информированиецелевых аудиторийн",
      },
      {
        code: "11",
        value:
          "Требуется вводное крупномасштабное информирование целевых аудиторий",
      },
      {
        code: "12",
        value:
          "Не требуется периодическое поддерживающее информирование целевых аудиторий",
      },
      {
        code: "13",
        value: "Требуется постоянное поддерживающее информирование участников",
      },
      {
        code: "14",
        value: "Требуется крупномасштабное вводное информирование участников",
      },
      {
        code: "15",
        value:
          "Не требуется вводное крупномасштабное информирование участников",
      },
      {
        code: "16",
        value:
          "Не требуется постоянное крупномасштабное поддерживающее информирование участников",
      },
      {
        code: "17",
        value:
          "Требуется периодическое избирательной информирование участников",
      },
      {
        code: "18",
        value:
          "Не требуется периодическое избирательное информирование участников",
      },
    ],
  };

  dictionary[36] = {
    value: "Обоснование статистической модели исследования",
    data: [
      {
        code: "01",
        value: "Расчет репрезентативной выборки вручную по формулам",
      },
      {
        code: "02",
        value:
          "Расчет репрезентативной выборки  по статистической программе «Статистика» автором",
      },
      {
        code: "03",
        value: "Расчет  репрезентативной выборки приглашенным экспертом",
      },
      { code: "04", value: "Расчет репрезентативной выборки отсутствует" },
    ],
  };

  (dictionary[100] = {
    value: "Область примененения",
    data: [
      { code: "1", value: "Организация здравоохранения" },
      { code: "2", value: "Научная" },
      { code: "3", value: "Медицинская технология" },
      // { code: "9", value: "Прочая" },
    ],
  }),
    (dictionary[101] = {
      value: "Объем финансирования НИР",
      data: [
        { code: "1", value: "до 1 млн. руб." },
        { code: "2", value: "от 1 до 10 млн. руб." },
        { code: "3", value: "от 10 до 50 млн. руб." },
        { code: "4", value: "от 50 до 100 млн. руб." },
        { code: "5", value: "свыше 100 млн. руб." },
      ],
    });
  dictionary[102] = {
    value: "Количество высококвалифицированных разработчиков",
    data: [
      { code: "1", value: "малый коллектив (до 5-ти)" },
      { code: "2", value: "от 5 до 20 (средний коллектив)" },
      { code: "3", value: "от 20 до 50" },
      { code: "4", value: "больше 50 (корпорация)" },
    ],
  };
  dictionary[103] = {
    value: "Период инвестиций",
    data: [
      { code: "1", value: "до 2 лет" },
      { code: "2", value: "от 2 до 5 лет" },
      { code: "3", value: "от 5 до 10" },
      { code: "4", value: "больше 10 лет" },
    ],
  };
  return dictionary;
}
